import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography, Button, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(10, 0),
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(6, 0),
    },
  },
  content: {
    textAlign: "center",
    maxWidth: 800,
    margin: "0 auto",
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    fontSize: "2.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  description: {
    fontSize: "1.25rem",
    marginBottom: theme.spacing(4),
    lineHeight: 1.6,
    opacity: 0.95,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "center",
    flexWrap: "wrap",
  },
  ctaButton: {
    padding: theme.spacing(1.5, 4),
    fontSize: "1.1rem",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 8,
    minWidth: 180,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
    },
  },
  primaryButton: {
    backgroundColor: "#ffffff",
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  secondaryButton: {
    backgroundColor: "transparent",
    color: "#ffffff",
    border: "2px solid #ffffff",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },
}));

const CTASection = ({ title, description, primaryCta, secondaryCta }) => {
  const classes = useStyles();

  const handleCtaClick = (url) => {
    if (url.startsWith("#")) {
      const element = document.querySelector(url);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else if (url.startsWith("/")) {
      window.location.href = url;
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box className={classes.section}>
      <Container className={classes.content}>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="h6" className={classes.description}>
          {description}
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            size="large"
            className={`${classes.ctaButton} ${classes.primaryButton}`}
            onClick={() => handleCtaClick(primaryCta.url)}
          >
            {primaryCta.text}
          </Button>
          {secondaryCta && (
            <Button
              variant="outlined"
              size="large"
              className={`${classes.ctaButton} ${classes.secondaryButton}`}
              onClick={() => handleCtaClick(secondaryCta.url)}
            >
              {secondaryCta.text}
            </Button>
          )}
        </div>
      </Container>
    </Box>
  );
};

export default CTASection;
